// datatable related plugins
import Breadcrumb from "components/Common/Breadcrumb";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  AUTH_STATUS_WAITING,
} from "constants/FormatDataContanst";
import { TYPE_ACTION_WORKFLOW } from "constants/IssueInvoiceConstant";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import {
  LINK_TYPE,
  TAX_DEDUCT_COMMON_FIELD,
} from "constants/TaxDeductConstant";
import {
  getFileNameExcel,
  numberWithCommas,
  useQueryRouter,
} from "helpers/utils";
import jwt_decode from "jwt-decode";
import HistoryMailTransferModal from "pages/DataFormatInvoice/modal/HistoryMailTransferModal";
import NoteModal from "pages/DataFormatInvoice/modal/NoteModal";
import { KyHieuMauHoaDonMode } from "pages/GeneralInfo/InvoiceSymbol/utils";
import SendMailModal from "pages/IssueInvoice/modal/SendMailModal";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  actionWorkflowIssueInvoice,
  cancelTaxDeducts,
  deleteTaxDeducts,
  downloadXmlTaxDeducts,
  exportInvoice,
  getDataLink,
  getListTaxDeducts,
  listInvoiceSymbol,
  resetActionWorkflowIssueInvoice,
  resetCancelTaxDeducts,
  resetCreateTaxDeducts,
  resetDeleteTaxDeducts,
  resetDownloadXmlTaxDeducts,
  resetEditTaxDeducts,
  resetExportInvoice,
  resetListTaxDeducts,
  setColumnVisibleTaxDeducts,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
  ROLE_EINVOICE_KE_TOAN,
} from "store/auth/login/actionTypes";
import {
  CANCEL_TAX_DEDUCTS_FAIL,
  CANCEL_TAX_DEDUCTS_SUCCESS,
  CREATE_TAX_DEDUCTS_FAIL,
  CREATE_TAX_DEDUCTS_SUCCESS,
  DELETE_TAX_DEDUCTS_FAIL,
  DELETE_TAX_DEDUCTS_SUCCESS,
  DOWNLOAD_XML_TAX_DEDUCTS_FAIL,
  DOWNLOAD_XML_TAX_DEDUCTS_SUCCESS,
  EDIT_TAX_DEDUCTS_FAIL,
  EDIT_TAX_DEDUCTS_SUCCESS,
} from "store/data-format/actionTypes";
import {
  ACTION_WORKFLOW_ISSUE_INVOICE_FAIL,
  ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS,
  EXPORT_INVOICE_FAIL,
  EXPORT_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";

import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { getResourceIdXML } from "helpers/form_helper";
import { useGetParentBuTaxDeduct } from "hooks/taxDeduct/useTaxDeduct";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import HistoryTransferModal from "pages/DataFormatInvoice/modal/HistoryTransferModal";
import ProgressExport from "pages/ExportInvoice/ProgressExport";
import CompareTaxDeductDetailModal from "pages/IssueInvoice/modal/CompareTaxDeductDetailModal";
import ConfirmActionInvoice from "pages/IssueInvoice/modal/ConfirmActionInvoice";
import {
  customFilterHeader,
  getLastThreeMonthsRange,
  mapDateColumnFilter,
} from "pages/IssueInvoice/utils";
import { TYPE_REPORT } from "pages/ReportInvoiceError/helper/functionHelper";
import DetailData from "./DetailData";
import { getInvoiceStatus } from "./helper/functionHelper";
import PDFViewModal from "./modal/PDFViewModal";
import {
  COMMON_CONDITION_VISIBLE_TAX_DEDUCT,
  getCurrentKhctu,
  getRowTaxDeductReplaceAdjustInfo,
  getTypeWorkflowTaxDeductMessage,
  MODE_FORM,
  MODE_TAX_DEDUCT_ACTION,
  tableFormateDate,
} from "./utils";

const ListData = props => {
  const history = useHistory();

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo, buStoreHeader } = Dashboard;

  const {
    mutate: mutateGetParentBuTaxDeduct,
    isLoading: isLoadingGetParentBuTaxDeduct,
    data: dataParentBuTaxDeduct,
  } = useGetParentBuTaxDeduct({
    onSuccess: response => {
      console.log("🚀 ~ mutateGetParentBuTaxDeduct ~ response:", response);
    },
    onError: error => {
      console.log("🚀 ~ mutateGetParentBuTaxDeduct ~ error:", error);
    },
  });

  const defaultDateRange = getLastThreeMonthsRange({ customMonth: 1 });

  const [defaultValueFilterHeader, setDefaultValueFilterHeader] = useState({
    value: defaultDateRange.originalDate,
    formattedValue: defaultDateRange.formattedDate,
    comparator: "~",
  });

  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const remoteTableRef = useRef(null);
  // CompareTaxDeductModal
  const [dataCompare, setDataCompare] = useState(null);
  const [modalCompareTaxDeduct, setModalCompareTaxDeduct] = useState(false);
  const toggleCompareTaxDeductModal = () =>
    setModalCompareTaxDeduct(!modalCompareTaxDeduct);
  // modalConfirmAction (Replace or Adjust invoice)
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(false);
  const toggleConfirmActionModal = () =>
    setModalConfirmAction(!modalConfirmAction);
  // Workflow modal
  const [modalWorkflow, setModalWorkflow] = useState(false);
  const toggleWorkflowModal = () => setModalWorkflow(!modalWorkflow);
  const [dataWorkflow, setDataWorkflow] = useState({
    id: null,
    typeWorkflow: null,
    titleModal: null,
    bodyModal: null,
  });
  // Lí do từ chối duyệt
  const [noteReject, setNoteReject] = useState(null);
  const [modalReject, setModalReject] = useState(false);
  const toggleRejectModal = () => setModalReject(!modalReject);

  // modalHistoryMailTransfer
  const [idHistoryMail, setIdHistoryMail] = useState(null);
  const [modalHistoryMailTransfer, setModalHistoryMailTransfer] =
    useState(false);
  const toggleHistoryMailTransferModal = () =>
    setModalHistoryMailTransfer(!modalHistoryMailTransfer);

  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);
  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);
  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);
  // modalErrorRelease
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  // modalHistoryTransfer
  const [idHistory, setIdHistory] = useState(null);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  // toggleSendMailModal
  const [modalSendMail, setModalSendMail] = useState(false);
  const toggleSendMailModal = () => setModalSendMail(!modalSendMail);
  const [mailData, setMailData] = useState({
    idInvoice: null,
    mailDefault: null,
  });
  // Release modal
  const [idRelease, setIdRelease] = useState(null);
  // Confirm Cancel modal
  const [modalConfirmCancel, setModalConfirmCancel] = useState(false);
  const toggleConfirmCancelModal = () => {
    if (modalConfirmCancel) {
      setTaxDeductSelect([]);
      remoteTableRef?.current?.clearCheckboxRowSelect();
    }
    setModalConfirmCancel(!modalConfirmCancel);
  };
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [modalRelease, setModalRelease] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const toggleReleaseModal = () => setModalRelease(!modalRelease);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);
  const toggleViewDetailModal = isResetList => {
    if (isResetList === true) {
      dispatch(getListTaxDeducts(params));
    }
    setModalDetail(!modalDetail);
  };
  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    type: typeIssueInvoice,
    releaseTaxDeductData,
    workflowInvoice,
    exportInvoiceData,
    fileDownloadName,
  } = issueInvoice;

  const [dataExport, setDataExport] = useState({
    reportId: null,
    fileName: null,
  });

  useEffect(() => {
    let mess = "";
    switch (typeIssueInvoice) {
      case EXPORT_INVOICE_SUCCESS: {
        dispatch(resetExportInvoice());
        setTimeout(() => {
          setDataExport({
            reportId: exportInvoiceData?.reportId,
            fileName: fileDownloadName,
          });
        });
        break;
      }
      case EXPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        if (exportInvoiceData?.error?.response?.status === 413) {
          addToast("Vui lòng giảm bớt số cột cần xuất dữ liệu", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetExportInvoice());
        break;
      case ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS:
        mess =
          getTypeWorkflowTaxDeductMessage(workflowInvoice.typeWorkflow) +
          " thành công";
        addToast(mess, {
          appearance: "success",
          autoDismiss: true,
        });
        if (modalWorkflow) {
          toggleWorkflowModal();
        }
        dispatch(getListTaxDeducts(params));
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      case ACTION_WORKFLOW_ISSUE_INVOICE_FAIL:
        mess =
          getTypeWorkflowTaxDeductMessage(workflowInvoice.typeWorkflow) +
          " thất bại";
        addToast(mess, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetActionWorkflowIssueInvoice());
        break;
    }
  }, [typeIssueInvoice]);

  // List KHCTU
  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const {
    errorList: errorInvoiceSymbolList,
    list: invoiceSymbolList,
    loadingList,
  } = invoiceSymbol;
  const [selectKHCT, setSelectKHCT] = useState(null);
  const [optionKHCT, setOptionsKHCT] = useState([]);

  // Ký hiệu chứng từ hiện tại (theo năm hiện tại)
  const currentKhctu = getCurrentKhctu();
  useEffect(() => {
    if (invoiceSymbolList?.items?.length > 0) {
      const prefix = `/${new Date().getFullYear().toString().slice(-2)}E`;
      const optionData =
        invoiceSymbolList?.items?.map(item => {
          const data = item?.khhdon + prefix;
          return {
            value: data,
            label: data,
          };
        }) || [];
      setOptionsKHCT(optionData);
      setSelectKHCT(optionData[0]);
      // Menu lập chứng từ open modal create
      if (
        query?.get("create") &&
        ![ALL_STORE, ALL_BU].includes(buStoreHeader)
      ) {
        setDataDetail({
          mode: MODE_FORM.ADD,
          khctu: currentKhctu,
        });
        if (!modalDetail) {
          toggleViewDetailModal();
        }
        // remove query create
        history.replace(window.location.pathname, { create: undefined });
      }
    } else {
      setOptionsKHCT([]);
      setSelectKHCT(null);
    }
  }, [invoiceSymbolList, buStoreHeader]);

  useEffect(() => {
    // Menu lập chứng từ open modal create
    if (query?.get("create") && selectKHCT) {
      setDataDetail({
        mode: MODE_FORM.ADD,
        khctu: currentKhctu,
      });
      if (!modalDetail) {
        toggleViewDetailModal();
      }
    }
  }, [window.location.search]);
  // store reducer
  const dataFormat = useSelector(state => state.dataFormat);
  const { loading: loadingDelete } = dataFormat.deleteTaxDeductsData;
  const { loading: loadingCancel } = dataFormat.cancelTaxDeductsData;
  const { fileDownload, type, fileDownloadName: fileDownloadNameDataFormat } = dataFormat;
  const { loading, listData, totalCount, columnsVisible, params } =
    dataFormat.taxDeducts;

  const [taxDeductSelect, setTaxDeductSelect] = useState([]);
  const selectRowCheckbox = {
    mode: "checkbox",
    // clickToSelect: true,
    nonSelectable: listData
      .filter(item => item.auth_status !== AUTH_STATUS_APPROVE)
      .map(item => item.id),
  };
  const onRowsSelect = value => {
    setTaxDeductSelect(value);
  };

  const { t, i18n } = useTranslation(["taxDeduct"]);

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  // useEffect(() => {
  //   initColumn();
  // }, [commonStatus]);

  let query = useQueryRouter();

  useEffect(() => {
    switch (type) {
      case CREATE_TAX_DEDUCTS_SUCCESS:
        addToast(t("form.submit.create.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleViewDetailModal();
        dispatch(getListTaxDeducts(params));
        dispatch(resetCreateTaxDeducts());
        break;
      case CREATE_TAX_DEDUCTS_FAIL:
        addToast(t("form.submit.create.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCreateTaxDeducts());
        break;

      case EDIT_TAX_DEDUCTS_SUCCESS:
        addToast(t("form.submit.edit.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleViewDetailModal();
        dispatch(getListTaxDeducts(params));
        dispatch(resetEditTaxDeducts());
        break;
      case EDIT_TAX_DEDUCTS_FAIL:
        addToast(t("form.submit.edit.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetEditTaxDeducts());
        break;
      case DELETE_TAX_DEDUCTS_SUCCESS:
        addToast(t("form.submit.delete.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmDeleteModal();
        dispatch(getListTaxDeducts(params));
        dispatch(resetDeleteTaxDeducts());
        break;
      case DELETE_TAX_DEDUCTS_FAIL:
        addToast(t("form.submit.delete.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDeleteTaxDeducts());
        break;
      case CANCEL_TAX_DEDUCTS_SUCCESS:
        setTaxDeductSelect([]);
        addToast(t("form.submit.cancel.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        if (modalConfirmCancel) {
          toggleConfirmCancelModal();
        }
        dispatch(getListTaxDeducts(params));
        dispatch(resetCancelTaxDeducts());
        break;
      case CANCEL_TAX_DEDUCTS_FAIL:
        addToast(t("form.submit.cancel.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCancelTaxDeducts());
        break;
      case DOWNLOAD_XML_TAX_DEDUCTS_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            console.log(" DOWNLOAD_XML_TAX_DEDUCTS_SUCCESS", { fileDownloadNameDataFormat })
            link.setAttribute("download", fileDownloadNameDataFormat);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlTaxDeducts());
        break;
      }
      case DOWNLOAD_XML_TAX_DEDUCTS_FAIL:
        if (!modalUSBSign) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlTaxDeducts());
        break;
      default:
        break;
    }
  }, [type]);

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      params.page = 1;
      if (query.get("report_id")) {
        params.columnFilter = {
          ...params.columnFilter,
          "filter[report_id]": query.get("report_id"),
        };
      }
      if (query.get("export_id")) {
        params.columnFilter = {
          ...params.columnFilter,
          "filter[export_id]": query.get("export_id"),
        };
      }
      const dateDefault = defaultDateRange.formattedDate;
      params.columnFilter = {
        ...params.columnFilter,
        "filter[ttchung_nlap][gte]": dateDefault[0],
        "filter[ttchung_nlap][lte]": dateDefault[1],
      };
      dispatch(getListTaxDeducts(params));
    }
  }, [finalBuInfo]);

  // Action list chang tenantCode
  //   useEffect(() => {
  //     if (tenantCodeHeader) {
  //       params.page = 1;
  //       dispatch(getListTaxDeducts(params));
  //     }
  //   }, [tenantCodeHeader]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);
  const [isRoleAccountant, setIsRoleAccountant] = useState(false);

  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const roleUser = info["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      const isRoleStore =
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false;
      const isRoleAccountant =
        listRole.findIndex(item => item === ROLE_EINVOICE_KE_TOAN) !== -1
          ? true
          : false;
      console.log("Thông tin vai trò người dùng ", {
        listRole,
        isRoleStore,
        isRoleAccountant,
      });
      setIsRoleStore(isRoleStore);
      setIsRoleAccountant(isRoleAccountant);
    }
    //
    const param = {
      isTaxDeduct: true,
      page: -1,
      columnFilter: {
        "filter[record_status]": "O",
        "filter[khmhdon]": KyHieuMauHoaDonMode.TAX_DEDUCT,
      },
    };
    dispatch(listInvoiceSymbol(param));
    mutateGetParentBuTaxDeduct();
    //
    return () => {
      dispatch(resetListTaxDeducts());
    };
  }, []);

  useEffect(() => {
    if (finalBuInfo || [ALL_STORE, ALL_BU].includes(buStoreHeader)) {
      console.log("Có thông tin đơn vị hiện tại, khởi tạo các cột", {
        finalBuInfo,
        buStoreHeader,
      });
      initColumn(true);
    }
  }, [finalBuInfo, buStoreHeader]);

  const initColumn = (loadDefaultFilter = false) => {
    const columns = getInitColumns(loadDefaultFilter);
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of columns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    console.log("Khởi tạo các cột", {
      columns,
      columnsVisible,
      loadDefaultFilter,
    });
    setColumns(columns);
  };

  const resetFilterHandle = () => {
    setDefaultValueFilterHeader({
      comparator: "~",
      value: [],
      formattedValue: [],
    });
    // Reset colums
    initColumn(false);
    // Reset filter call api
    params.columnFilter = {};
    dispatch(getListTaxDeducts(params));
    // let columnsVisibleInvoice = dataDefaultFilter?.columnsVisible;
    // setColumnsTable(formatHiddenColumn(columnsVisibleInvoice, columns));
    // // Reset filter call api
    // invoicePosList.params.columnFilter = {
    //   ...filterList,
    //   "filter[invoice_type]": finalBuInfo?.invoice_type,
    // };
    // delete invoicePosList.params.keywords;
    // resetDataFunc();
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      //   setDataDetail({
      //     content: row.content,
      //     file_name: row.file_name,
      //     process_upload_id: row.id,
      //     status: row.status,
      //   });
      setDataDetail({ id: row.id, mode: MODE_FORM.VIEW });
      toggleViewDetailModal();
    },
  };
  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };

  const showSendMail = row => {
    setMailData({
      idInvoice: row.id,
      mailDefault: row.nnt_dctdtu,
    });
    toggleSendMailModal();
  };

  const listRowAction = useMemo(() => {
    const listAction = [
      {
        icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
        text: "Xem trước bản hiển thị",
        conditionVisible: {
          resource_id: [],
        },
        onClick: row => {
          showPdfById(row.id);
        },
      },
      {
        icon: <i className="bx bx-download font-size-18 text-primary" />,
        isDropdown: true,
        classDropdown: "dropdown-menu-3",
        conditionVisible: {
          resource_list: [],
        },
        listDropdown: [
          {
            text: "Phản hồi TVAN (Mltdiep213)",
            icon: <i className="bx bxs-file text-primary" />,
            conditionVisible: {
              isHaveMltdiep213: ["TRUE"],
            },
            onClick: row => {
              const resource_id = getResourceIdXML(
                row.resource_list,
                "tct-response",
                "213"
              );
              if (resource_id) {
                dispatch(
                  downloadXmlTaxDeducts(
                    resource_id,
                    `Mltdiep213_${row[TAX_DEDUCT_COMMON_FIELD.TTCHUNG_THDON.field]
                    }`
                  )
                );
              } else {
                addToast("Tải xuống thất bại", {
                  appearance: "error",
                  autoDismiss: true,
                });
              }
            },
          },
          {
            text: "Chứng từ đã ký",
            icon: <i className="bx bxs-file text-success" />,
            conditionVisible: {
              isHaveSigned: ["TRUE"],
            },
            onClick: row => {
              const resource_id = getResourceIdXML(row.resource_list, "signed");
              if (resource_id) {
                dispatch(
                  downloadXmlTaxDeducts(
                    resource_id,
                    `Signed_${row[TAX_DEDUCT_COMMON_FIELD.TTCHUNG_THDON.field]}`
                  )
                );
              } else {
                addToast("Tải xuống thất bại", {
                  appearance: "error",
                  autoDismiss: true,
                });
              }
            },
          },
          {
            text: "Chứng từ",
            icon: <i className="bx bxs-file text-default" />,
            conditionVisible: {
              isHaveRaw: ["TRUE"],
            },
            onClick: row => {
              const resource_id = getResourceIdXML(row.resource_list, "raw");
              if (resource_id) {
                dispatch(
                  downloadXmlTaxDeducts(
                    resource_id,
                    `Raw_${row[TAX_DEDUCT_COMMON_FIELD.TTCHUNG_THDON.field]}`
                  )
                );
              } else {
                addToast("Tải xuống thất bại", {
                  appearance: "error",
                  autoDismiss: true,
                });
              }
            },
          },
        ],
        text: "Download XML",
      },
      // START Luồng duyệt và phát hành CTKT (Không có trong đợt CTKT)
      {
        icon: <i className="bx bx-send text-primary" />,
        text: "Gửi duyệt CTKT",
        isShow:
          finalBuInfo?.need_approve === 1 && (isRoleStore || isRoleAccountant),
        conditionVisible: COMMON_CONDITION_VISIBLE_TAX_DEDUCT.SEND_APPROVE,
        onClick: row => {
          setDataWorkflow({
            id: row.id,
            typeWorkflow: TYPE_ACTION_WORKFLOW.SUBMIT,
            titleModal: "Xác nhận gửi duyệt CTKT",
            bodyModal: "Hệ thống sẽ gửi duyệt CTKT này",
          });
          toggleWorkflowModal();
        },
      },
      {
        icon: <i className="bx bxs-x-circle text-danger" />,
        text: "Từ chối duyệt CTKT",
        isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
        conditionVisible: COMMON_CONDITION_VISIBLE_TAX_DEDUCT.REJECT,
        onClick: row => {
          setDataWorkflow({
            id: row.id,
            typeWorkflow: TYPE_ACTION_WORKFLOW.REJECT,
            titleModal: "Xác nhận từ chối duyệt CTKT",
            bodyModal: "Lý do từ chối",
          });
          toggleWorkflowModal();
        },
      },
      {
        icon: <i className="bx bxs-check-circle text-success" />,
        text: "Duyệt CTKT",
        isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
        conditionVisible: COMMON_CONDITION_VISIBLE_TAX_DEDUCT.APPROVE,
        onClick: row => {
          setDataWorkflow({
            id: row.id,
            typeWorkflow: TYPE_ACTION_WORKFLOW.APPROVE,
            titleModal: "Xác nhận duyệt CTKT này",
            bodyModal: "Hệ thống sẽ duyệt và phát hành CTKT này",
          });
          toggleWorkflowModal();
        },
      },
      {
        icon: <i className="bx bx-edit font-size-18 text-success" />,
        text: "Cập nhật chứng từ",
        isShow: ![ALL_STORE, ALL_BU].includes(buStoreHeader),
        conditionVisible: COMMON_CONDITION_VISIBLE_TAX_DEDUCT.EDIT,
        onClick: row => {
          setDataDetail({ id: row.id, mode: MODE_FORM.EDIT });
          setIdRelease(row.id);
          toggleViewDetailModal();
          setDataConfirmAction(null);
        },
      },
      {
        icon: <i className="bx bx-trash text-danger" />,
        text: "Xóa bỏ",
        isShow: ![ALL_STORE, ALL_BU].includes(buStoreHeader),
        conditionVisible: COMMON_CONDITION_VISIBLE_TAX_DEDUCT.DELETE,
        onClick: row => {
          setDataViewDocument({
            id: row.id,
          });
          toggleConfirmDeleteModal();
        },
      },
      // END Luồng duyệt và phát hành CTKT (Không có trong đợt CTKT)
      // START Luồng duyệt và phát hành CTKT (Thay Thế / Điều Chỉnh) (Nằm trong đợt CTKT)
      {
        icon: <i className="bx bx-send text-primary" />,
        text: "Gửi duyệt CTKT",
        isShow:
          finalBuInfo?.need_approve === 1 && (isRoleStore || isRoleAccountant),
        conditionVisible:
          COMMON_CONDITION_VISIBLE_TAX_DEDUCT.SEND_APPROVE_FROM_IMPORT,
        onClick: row => {
          setDataWorkflow({
            id: row.id,
            typeWorkflow: TYPE_ACTION_WORKFLOW.SUBMIT,
            titleModal: "Xác nhận gửi duyệt CTKT",
            bodyModal: "Hệ thống sẽ gửi duyệt CTKT này",
          });
          toggleWorkflowModal();
        },
      },
      {
        icon: <i className="bx bxs-x-circle text-danger" />,
        text: "Từ chối duyệt CTKT",
        isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
        conditionVisible:
          COMMON_CONDITION_VISIBLE_TAX_DEDUCT.REJECT_FROM_IMPORT,
        onClick: row => {
          setDataWorkflow({
            id: row.id,
            typeWorkflow: TYPE_ACTION_WORKFLOW.REJECT,
            titleModal: "Xác nhận từ chối duyệt CTKT",
            bodyModal: "Lý do từ chối",
          });
          toggleWorkflowModal();
        },
      },
      {
        icon: <i className="bx bxs-check-circle text-success" />,
        text: "Duyệt CTKT",
        isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
        conditionVisible:
          COMMON_CONDITION_VISIBLE_TAX_DEDUCT.APPROVE_FROM_IMPORT,
        onClick: row => {
          setDataWorkflow({
            id: row.id,
            typeWorkflow: TYPE_ACTION_WORKFLOW.APPROVE,
            titleModal: "Xác nhận duyệt CTKT này",
            bodyModal: "Hệ thống sẽ duyệt và phát hành CTKT này",
          });
          toggleWorkflowModal();
        },
      },
      {
        icon: <i className="bx bx-edit font-size-18 text-success" />,
        text: "Cập nhật chứng từ",
        conditionVisible: COMMON_CONDITION_VISIBLE_TAX_DEDUCT.EDIT_FROM_IMPORT,
        onClick: row => {
          setDataDetail({ id: row.id, mode: MODE_FORM.EDIT });
          setIdRelease(row.id);
          toggleViewDetailModal();
          setDataConfirmAction(null);
        },
      },
      {
        icon: <i className="bx bx-trash text-danger" />,
        text: "Xóa bỏ",
        conditionVisible:
          COMMON_CONDITION_VISIBLE_TAX_DEDUCT.DELETE_FROM_IMPORT,
        onClick: row => {
          setDataViewDocument({
            id: row.id,
          });
          toggleConfirmDeleteModal();
        },
      },
      // END Luồng duyệt và phát hành CTKT (Thay Thế / Điều Chỉnh) (Nằm trong đợt CTKT)
      {
        icon: <i className="far fa-newspaper text-success" />,
        isDropdown: true,
        classDropdown: "dropdown-menu-2",
        listDropdown: [
          {
            icon: <i className="bx bx-rotate-left text-primary" />,
            text: "Thay thế",
            isShow: buStoreHeader !== ALL_STORE,
            conditionVisible: COMMON_CONDITION_VISIBLE_TAX_DEDUCT.REPLACE,
            onClick: row => {
              setDataConfirmAction({
                id: row.id,
                mode: MODE_TAX_DEDUCT_ACTION.REPLACE,
                pattern: row.ttchung_msctu,
                serial: row.ttchung_khctu,
                invoiceNo: row.ttchung_sctu || "Chưa cấp số",
                nlap: row.ttchung_nlap,
              });
              toggleConfirmActionModal();
            },
          },
          {
            icon: <i className="bx bx-edit text-primary" />,
            text: "Điều chỉnh",
            isShow: buStoreHeader !== ALL_STORE,
            conditionVisible: COMMON_CONDITION_VISIBLE_TAX_DEDUCT.ADJUST,
            onClick: row => {
              setDataConfirmAction({
                id: row.id,
                mode: MODE_TAX_DEDUCT_ACTION.ADJUST,
                pattern: row.ttchung_msctu,
                serial: row.ttchung_khctu,
                invoiceNo: row.ttchung_sctu || "Chưa cấp số",
                nlap: row.ttchung_nlap,
              });
              toggleConfirmActionModal();
            },
          },
        ],
        text: "Nghiệp vụ",
      },
      {
        icon: <i className="bx bx-history font-size-18 text-success" />,
        text: "Lịch sử truyền nhận",
        onClick: row => {
          setIdHistory(row.id);
          toggleHistoryTransferModal();
        },
      },
      {
        icon: <i className="bx bx-history font-size-18 text-warning" />,
        text: "Lịch sử gửi mail",
        onClick: row => {
          setIdHistoryMail(row.id);
          toggleHistoryMailTransferModal();
        },
      },

      {
        icon: <i className="bx bx-mail-send text-success" />,
        text: "Gửi mail",
        conditionVisible: {
          resource_id: [],
        },
        onClick: row => {
          showSendMail(row);
        },
      },
    ];
    console.log("Thông tin danh sách thao tác", { listAction });
    return listAction;
  }, [finalBuInfo, buStoreHeader, isRoleStore, isRoleAccountant]);

  const exportFormatData = () => {
    let objectExport = {};
    columns
      .filter(item => item.hidden === false || item.hidden === undefined)
      .map(item => {
        const formatData = {
          id: item.id,
          dataField: item.dataField,
          hidden: item.hidden,
          text: item.text,
        };

        let key = `columns[${formatData.dataField}][label]`;
        // Format data
        switch (formatData.dataField) {
          case "display_name":
            key = `columns[displayName][label]`;
            break;
          case "link_type":
            for (const key in selectFilterLinkType) {
              objectExport[
                `columns[${formatData.dataField}][mapping][${key}]`
              ] = selectFilterLinkType[key];
            }
            break;
          case "pending_van":
            // objectExport[`columns[${formatData.dataField}][mapping][0]`] =
            //   "Đã gửi";
            // objectExport[`columns[${formatData.dataField}][mapping][1]`] =
            //   "Chưa gửi";
            break;
          case "auth_status":
            // for (const key in selectFilterAuthStatus) {
            //   objectExport[
            //     `columns[${formatData.dataField}][mapping][${key}]`
            //   ] = selectFilterAuthStatus[key];
            // }
            break;
          case "approve_status":
            // for (const key in selectFilterApproveStatus) {
            //   objectExport[
            //     `columns[${formatData.dataField}][mapping][${key}]`
            //   ] = selectFilterApproveStatus[key];
            // }
            break;
          case "sent":
            // objectExport[`columns[${formatData.dataField}][mapping][0]`] =
            //   "Chưa gửi mail";
            // objectExport[`columns[${formatData.dataField}][mapping][1]`] =
            //   "Đã gửi mail";
            break;
          case "ttchung_khmshdon":
            // objectExport[`columns[${formatData.dataField}][mapping][1]`] =
            //   "HÓA ĐƠN GTGT";
            // objectExport[`columns[${formatData.dataField}][mapping][2]`] =
            //   "HÓA ĐƠN BH";
            break;
          case "ttchung_sctu":
            objectExport[`columns[${formatData.dataField}][mapping][null]`] =
              "Chờ cấp số";
            break;
          case "ttchung_nlap":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          case "signing_date":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          case "checker_date":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          case "ttncnktru_sthue":
            objectExport[`columns[${formatData.dataField}][type]`] = "currency";
            break;
          default:
            break;
        }
        // Format style
        switch (formatData.dataField) {
          case "nmua_ten":
            objectExport[
              `columns[${formatData.dataField}][contentOptions][alignment][wrapText]`
            ] = true;
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][width]`
            ] = 80;
            break;
          case "display_name":
            objectExport[
              `columns[displayName][dimensionOptions][autoSize]`
            ] = true;
            break;
          default:
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][autoSize]`
            ] = true;
            break;
        }
        //
        const value = formatData.text;
        objectExport[key] = value;

        return formatData;
      });
    console.log("🚀 ~ exportFormatData :", { objectExport });
    return objectExport;
  };

  const listMultipleRowAction = [
    {
      icon: <i className="far fa-file-excel font-size-18 text-success" />,
      text: "Xuất danh sách chứng từ",
      isLoading: exportInvoiceData.loading,
      isDisabled: totalCount === 0,
      loadingText: "Đang xuất danh sách chứng từ",
      onClick: data => {
        let objectExport = exportFormatData();
        objectExport = {
          ...objectExport,
          ...params.columnFilter,
          sort: params.sort ? params.sort : "-checker_date",
          keywords: params.keywords,
        };
        if (dataExport.reportId) {
          setDataExport({
            reportId: null,
            fileName: null,
          });
          setTimeout(() => {
            dispatch(
              exportInvoice(
                objectExport,
                getFileNameExcel("DanhSachChungTu"),
                "tax-deduct-details/export-console",
                TYPE_REPORT.TAX_DEDUCT_EXPORT
              )
            );
          });
        } else {
          dispatch(
            exportInvoice(
              objectExport,
              getFileNameExcel("DanhSachChungTu"),
              "tax-deduct-details/export-console",
              TYPE_REPORT.TAX_DEDUCT_EXPORT
            )
          );
        }
      },
    },
  ];

  const getAuthStatus = row => {
    let status = row.auth_status;
    let process_status = row.process_status;
    let id = row.id;
    let child = row.child;
    let root = row.root;
    let infoError = null;
    let progressDiv = null;
    let info = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    info = getRowTaxDeductReplaceAdjustInfo(
      row,
      setDataCompare,
      dispatch,
      getDataLink,
      toggleCompareTaxDeductModal
    );
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            style={{ width: "110px", whiteSpace: "initial" }}
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>

          {infoError}
          {info}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_WAITING]: commonStatus?.AUTH_STATUS[AUTH_STATUS_WAITING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    [AUTH_STATUS_CANCEL]: commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL]?.text, // "Hủy",
  };

  const getSelectFilterApproveStatus = () => {
    const filter = {};
    let listFilter = [
      APPROVE_STATUS_M,
      APPROVE_STATUS_P,
      APPROVE_STATUS_A,
      APPROVE_STATUS_R,
    ];
    // if (isRoleAccountant) {
    //   listFilter = [APPROVE_STATUS_P, APPROVE_STATUS_A];
    // }
    for (const item of listFilter) {
      if (selectFilterApproveStatus[item]) {
        filter[item] = selectFilterApproveStatus[item];
      }
    }
    return filter;
  };

  const selectFilterApproveStatus = {
    [APPROVE_STATUS_M]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_M]?.text, // "Lưu tạm",
    [APPROVE_STATUS_P]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_P]?.text, // "Gửi chờ duyệt",
    [APPROVE_STATUS_A]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_A]?.text, // "Đã duyệt",
    [APPROVE_STATUS_R]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_R]?.text, // "Từ chối duyệt",
  };

  const getApproveStatus = row => {
    let status = row.approve_status;
    let note_deny = row?.approve_note?.workflowNote;
    let infoError = null;
    if (status === APPROVE_STATUS_R) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setNoteReject(note_deny);
            toggleRejectModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1" title={note_deny}>
          <Badge
            className={`font-size-12 ${commonStatus?.APPROVE_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.APPROVE_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const getLinkType = row => {
    let text = "";
    let className = "";
    let type = "";
    switch (row.link_type) {
      case LINK_TYPE.PARENT_REPLACE:
        className = "text-success";
        text = `CTKT GỐC  (Bị thay thế)`;
        break;
      case LINK_TYPE.PARENT_ADJUST:
        className = "text-success";
        text = `CTKT GỐC  (Bị điều chỉnh)`;
        break;
      case LINK_TYPE.CHILD_REPLACE:
        className = "text-info";
        text = "CTKT THAY THẾ";
        break;
      case LINK_TYPE.CHILD_ADJUST:
        className = "text-primary";
        switch (row.adjust_mod) {
          case TYPE_ACTION_WORKFLOW.INCREASE:
            type = "TĂNG";
            break;
          case TYPE_ACTION_WORKFLOW.DECREASE:
            type = "GIẢM";
            break;
          case TYPE_ACTION_WORKFLOW.CHANGE_INFO:
            type = "THÔNG TIN";
            break;
          default:
            break;
        }
        text = "CTKT ĐIỀU CHỈNH " + type;
        break;
      default:
        className = "text-success";
        text = "CTKT BÌNH THƯỜNG";
        break;
    }

    return (
      <React.Fragment>
        <div className={className} style={{ fontWeight: "bold" }}>
          {text}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterLinkType = {
    [LINK_TYPE.NORMAL]: "CTKT bình thường",
    [LINK_TYPE.PARENT_REPLACE]: "CTKT gốc (bị thay thế)",
    [LINK_TYPE.PARENT_ADJUST]: "CTKT gốc (bị điều chỉnh)",
    [LINK_TYPE.CHILD_REPLACE]: "CTKT thay thế",
    [LINK_TYPE.CHILD_ADJUST]: "CTKT điều chỉnh",
  };

  const getSelectFilterLinkType = () => {
    return selectFilterLinkType;
  };

  const getInitColumns = (loadDefaultFilter = false) => {
    const initColumns = [
      {
        dataField: "id",
        text: "Id",
        sort: true,
        hidden: true,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
        }),
      },
      {
        dataField: "report_id",
        fieldSearch: "filter[report_id]",
        text: "Id đợt",
        sort: true,
        filter: textFilter({
          style: { maxWidth: "120px" },
          placeholder: t("placeholder.enter"),
          defaultValue: loadDefaultFilter
            ? query?.get("report_id") || undefined
            : undefined,
        }),
      },
      {
        dataField: "bu_code",
        text: "Mã đơn vị",
        sort: true,
        filter: [ALL_STORE, ALL_BU].includes(buStoreHeader)
          ? textFilter({
            placeholder: t("placeholder.enter"),
            style: { maxWidth: "120px" },
          })
          : undefined,
      },
      // {
      //   dataField: "export_id",
      //   text: t("table.export_id"),
      //   hidden: false,
      //   formatter: (cellContent, row) => {
      //     return (
      //       <React.Fragment>
      //         {cellContent ? (
      //           <div className="text-primary">Id: {cellContent}</div>
      //         ) : (
      //           <div className="text-warning">Chưa tạo</div>
      //         )}
      //       </React.Fragment>
      //     );
      //   },
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //     defaultValue: loadDefaultFilter
      //       ? query?.get("export_id") || undefined
      //       : undefined,
      //   }),
      // },
      // {
      //   dataField: "ttchung_msctu",
      //   text: t("table.ttchung_msctu"),
      //   hidden: false,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      // },
      {
        dataField: "ttchung_khctu",
        text: t("table.ttchung_khctu"),
        hidden: false,
        filter: textFilter({
          style: { maxWidth: "80px" },
          placeholder: t("placeholder.enter"),
        }),
        // formatter: (cellContent, row) => {
        //   return `${row.ttchung_msctu} ${row.ttchung_khctu}`;
        // },
      },
      {
        dataField: "client_ref_uuid",
        text: "Số tham chiếu",
        sort: true,
        fieldSearch: "filter[client_ref_uuid]",
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          style: { width: "120px" },
        }),
        formatter: (cell, row) => {
          return (
            <div style={{ maxWidth: "120px", whiteSpace: "initial" }}>
              {cell}
            </div>
          );
        },
      },
      {
        dataField: "ttchung_sctu",
        text: t("table.ttchung_sctu"),
        hidden: false,
        filter: textFilter({
          style: { maxWidth: "80px" },
          placeholder: t("placeholder.enter"),
        }),
        formatter: (cellContent, row) => {
          return cellContent !== "0" && cellContent
            ? cellContent
            : "Chờ cấp số";
        },
      },
      {
        dataField: "link_type",
        text: "CTKT Gốc / Thay thế/ Điều chỉnh",
        // hidden: listLinkTypeFilter.length === 0,
        formatter: (cellContent, row) => getLinkType(row),
        filter: selectFilter({
          placeholder: t("placeholder.select"),
          options: getSelectFilterLinkType(),
          // style: { maxWidth: "140px" },
        }),
      },
      {
        dataField: "auth_status",
        text: t("auth_status.name"),
        hidden: false,
        formatter: (cellContent, row) => getAuthStatus(row),
        filter: selectFilter({
          style: { maxWidth: "120px" },
          placeholder: t("placeholder.select"),
          options: selectFilterAuthStatus,
        }),
      },
      {
        dataField: "approve_status",
        text: "Trạng thái duyệt",
        hidden: finalBuInfo?.need_approve === 0,
        formatter: (cellContent, row) => getApproveStatus(row),
        filter: selectFilter({
          placeholder: t("placeholder.select"),
          options: getSelectFilterApproveStatus(),
        }),
      },
      {
        dataField: "ttchung_nlap",
        text: t("table.ttchung_nlap"),
        formatter: (cellContent, row) =>
          tableFormateDate(row.ttchung_nlap, false),
        // filter: customFilter({
        //   type: CUSTOM_DATE_FILTER_TABLE_TYPE,
        // }),
        // filterRenderer: (onFilter, column) => (
        //   <CustomDateFilter
        //     onFilter={onFilter}
        //     column={column}
        //     paramFilter={params.columnFilter}
        //   />
        // ),
      },
      {
        dataField: "signing_date",
        text: t("table.signing_date"),
        formatter: (cellContent, row) =>
          tableFormateDate(row.signing_date, false),
        filter: customFilter({
          type: CUSTOM_DATE_FILTER_TABLE_TYPE,
        }),
        filterRenderer: (onFilter, column) => (
          <CustomDateFilter
            onFilter={onFilter}
            column={column}
            paramFilter={params.columnFilter}
          />
        ),
      },
      {
        dataField: "nnt_ten",
        text: t("table.nnt_ten"),
        hidden: false,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
        }),
      },
      {
        dataField: "nnt_mst",
        text: t("table.nnt_mst"),
        hidden: false,
        filter: textFilter({
          style: { maxWidth: "160px" },
          placeholder: t("placeholder.enter"),
        }),
      },
      {
        dataField: "nnt_cmnd",
        text: t("table.nnt_cmnd"),
        hidden: false,
        filter: textFilter({
          style: { maxWidth: "120px" },
          placeholder: t("placeholder.enter"),
        }),
      },
      {
        dataField: "ttncnktru_sthue",
        text: t("table.ttncnktru_sthue"),
        hidden: false,
        filter: textFilter({
          style: { maxWidth: "150px" },
          placeholder: t("placeholder.enter"),
        }),
        formatter: (cellContent, row) => numberWithCommas(Number(cellContent)),
      },
      {
        dataField: "gchu",
        text: t("table.gchu"),
        hidden: false,
      },
      {
        dataField: "maker_date",
        text: t("table.maker_date"),
        hidden: true,
        sort: true,
        formatter: (cellContent, row) => tableFormateDate(row.maker_date),
        filter: customFilter({
          type: CUSTOM_DATE_FILTER_TABLE_TYPE,
        }),
        filterRenderer: (onFilter, column) => (
          <CustomDateFilter
            onFilter={onFilter}
            column={column}
            paramFilter={params.columnFilter}
          />
        ),
      },
      {
        dataField: "maker_name",
        text: t("table.maker_id"),
        //   filter: textFilter({
        //     placeholder: t("placeholder.enter"),
        //   }),
        hidden: true,
      },
      {
        dataField: "checker_date",
        text: t("table.checker_date"),
        sort: true,
        formatter: (cellContent, row) => tableFormateDate(row.checker_date),
        filter: customFilter({
          type: CUSTOM_DATE_FILTER_TABLE_TYPE,
        }),
        filterRenderer: (onFilter, column) => (
          <CustomDateFilter
            onFilter={onFilter}
            column={column}
            paramFilter={params.columnFilter}
          />
        ),
      },
      {
        dataField: "checker_name",
        text: t("table.checker_id"),
        sort: true,
        //   filter: textFilter({
        //     placeholder: t("placeholder.enter"),
        //   }),
        hidden: true,
      },
      // {
      //   dataField: "resource_id",
      //   text: "resource_id",
      //   sort: true,
      // },
    ];
    return initColumns;
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.page = page;
    params.sizePerPage = sizePerPage;

    const ttchung_nlapColumnFilter = mapDateColumnFilter({
      field: "ttchung_nlap",
      columnFilter: params.columnFilter,
    });

    params.columnFilter = {
      ...ttchung_nlapColumnFilter,
      ...columnFilter,
    };
    console.log("🚀 ~ handleTableChange ~ getListTaxDeducts:", {
      columnFilter,
      params,
    });
    dispatch(getListTaxDeducts(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListTaxDeducts(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleTaxDeducts(field, value));
  };

  const actionReplaceOrAdjustInvoice = typeAdjust => {
    console.log("🚀 ~ actionReplaceOrAdjustInvoice ~ typeAdjust:", typeAdjust);
    setDataConfirmAction({
      ...dataConfirmAction,
      typeAdjust,
    });
    setDataDetail({ id: dataConfirmAction.id, mode: MODE_FORM.ADD });
    // // getListInvoiceSymbol(dataConfirmAction.pattern);
    // switch (dataConfirmAction.pattern) {
    //   case "1":
    //     setMode(issueInvoiceModeList.EDIT_VAT_INVOICE_DETAIL);
    //     break;
    //   case "2":
    //     setMode(issueInvoiceModeList.EDIT_SALE_INVOICE_DETAIL);
    //     break;
    //   default:
    //     break;
    // }
    toggleViewDetailModal();
  };

  return (
    <React.Fragment>
      {/*Từ chối duyệt Modal */}
      <NoteModal
        isOpen={modalReject}
        toggle={toggleRejectModal}
        note={noteReject}
        titleNote={"Lí do từ chối duyệt"}
      />
      {/* WORKFLOW modal */}
      <ConfirmModal
        toggle={toggleWorkflowModal}
        isOpen={modalWorkflow}
        titleHeader={dataWorkflow.titleModal}
        titleBody={dataWorkflow.bodyModal}
        isRequireNote={false}
        isDisableButton={workflowInvoice.loading}
        isHaveNote={dataWorkflow.typeWorkflow === TYPE_ACTION_WORKFLOW.REJECT}
        onConfirm={note => {
          dispatch(
            actionWorkflowIssueInvoice(
              dataWorkflow.id,
              dataWorkflow.typeWorkflow,
              note,
              "tax-deduct-details"
            )
          );
        }}
        textBtnConfirm={"Xác nhận"}
        textBtnCancel={"Đóng"}
      />
      {/* HistoryMailTransferModal */}
      <HistoryMailTransferModal
        isOpen={modalHistoryMailTransfer}
        toggle={toggleHistoryMailTransferModal}
        id={idHistoryMail}
        path={"tax-deduct-send-mail"}
      />
      {/* ErrorReleaseModal */}
      <ErrorReleaseModal
        isOpen={modalErrorRelease}
        toggle={toggleErrorReleaseModal}
        id={idRelease}
        path={"tax-deduct-details"}
      />
      {/* History TransferModal */}
      <HistoryTransferModal
        isOpen={modalHistoryTransfer}
        toggle={toggleHistoryTransferModal}
        id={idHistory}
        path={"tax-deduct-details"}
      />
      <DetailData
        showPdfById={showPdfById}
        dataConfirmAction={dataConfirmAction}
        dataDetail={dataDetail}
        isOpen={modalDetail}
        t={t}
        i18n={i18n}
        toggleReleaseModal={toggleReleaseModal}
        toggle={toggleViewDetailModal}
        finalBuReleaseInfo={dataParentBuTaxDeduct?.item}
      />
      <div className="page-content">
        <MetaTags>
          <title>{t("tax_deduct")}</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumb
            title=""
            breadcrumbItem={t("tax_deduct") + ` (${totalCount})`}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <ConfirmActionInvoice
                      isTaxDeduct={true}
                      confirmActionData={dataConfirmAction}
                      isOpen={modalConfirmAction}
                      toggle={toggleConfirmActionModal}
                      actionReplaceOrAdjustInvoice={
                        actionReplaceOrAdjustInvoice
                      }
                    />
                    <CompareTaxDeductDetailModal
                      showPdfById={showPdfById}
                      setDataCompare={setDataCompare}
                      dataCompare={dataCompare}
                      isOpen={modalCompareTaxDeduct}
                      toggle={toggleCompareTaxDeductModal}
                    />
                    {/* Cancel modal */}
                    <ConfirmModal
                      isOpen={modalConfirmCancel}
                      titleHeader={"Xác nhận hủy chứng từ"}
                      titleBody={`Hệ thống sẽ thực hiện hủy ${taxDeductSelect.length > 0
                        ? `(${taxDeductSelect.length})`
                        : ""
                        } chứng từ này ?`}
                      isDisableButton={loadingCancel}
                      onConfirm={note => {
                        dispatch(cancelTaxDeducts(taxDeductSelect));
                      }}
                      textBtnConfirm={"Xác nhận"}
                      textBtnCancel={"Đóng"}
                      toggle={toggleConfirmCancelModal}
                    />
                    {/* Deny modal */}
                    <ConfirmModal
                      isOpen={modalConfirmDelete}
                      titleHeader={"Xác nhận xóa chứng từ"}
                      titleBody={"Hệ thống sẽ thực hiện xóa chứng từ này ?"}
                      isDisableButton={loadingDelete}
                      onConfirm={note => {
                        dispatch(deleteTaxDeducts(dataViewDocument.id));
                      }}
                      textBtnConfirm={"Xác nhận"}
                      textBtnCancel={"Đóng"}
                      toggle={toggleConfirmDeleteModal}
                    />
                    {/* SendMailModal */}
                    <SendMailModal
                      isOpen={modalSendMail}
                      mailData={mailData}
                      toggle={toggleSendMailModal}
                      path={"tax-deduct-details"}
                    ></SendMailModal>
                    {/* PDFViewModal */}
                    <PDFViewModal
                      isOpen={modalPdfView}
                      dataViewDocument={dataViewDocument}
                      toggle={togglePdfViewModal}
                    ></PDFViewModal>
                    {dataExport?.reportId && (
                      <ProgressExport
                        typeReportProgress={TYPE_REPORT.TAX_DEDUCT_EXPORT}
                        funcComplete={() => {
                          setDataExport({
                            reportId: null,
                            fileName: null,
                          });
                        }}
                        idReport={dataExport?.reportId}
                        fileName={dataExport?.fileName}
                      />
                    )}
                    <RemoteDataTable
                      // ref={remoteTableRef}
                      keyField="id"
                      // selectRow={selectRowCheckbox}
                      onRowsSelect={onRowsSelect}
                      data={listData?.map(item => ({
                        ...item,
                        isHaveLinkType:
                          item.link_type !== null ? "TRUE" : "FALSE",
                        isHaveMltdiep213: item.resource_list.some(
                          item => item.mltdiep === "213"
                        )
                          ? "TRUE"
                          : "FALSE",
                        isHaveSigned: item.resource_list.some(
                          item => item.type === "signed"
                        )
                          ? "TRUE"
                          : "FALSE",
                        isHaveRaw: item.resource_list.some(
                          item => item.type === "raw"
                        )
                          ? "TRUE"
                          : "FALSE",
                      }))}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      listMultipleRowAction={listMultipleRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                      resetFilterHandle={resetFilterHandle}
                    >
                      {/* <div style={{ width: "125px", zIndex: 3 }}>
                        <Select
                          value={selectKHCT}
                          placeholder={"Vui lòng chọn ký hiệu"}
                          options={optionKHCT}
                          onChange={e => {
                            setSelectKHCT(e);
                          }}
                          classNamePrefix="select2-selection"
                        />
                      </div> */}
                      {![ALL_STORE, ALL_BU].includes(buStoreHeader) && (
                        <Button
                          type="button"
                          color="primary"
                          className="me-2 btn-label"
                          disabled={isLoadingGetParentBuTaxDeduct}
                          onClick={() => {
                            // if (toastWarningIsAllStore(addToast)) {
                            //   return;
                            // }
                            setDataCompare(null);
                            setDataDetail(null);
                            setIdRelease(null);
                            setDataConfirmAction(null);
                            setDataDetail({
                              mode: MODE_FORM.ADD,
                              khctu: currentKhctu,
                            });
                            toggleViewDetailModal();
                          }}
                        >
                          <i className="bx bx-plus label-icon" />
                          {t("button.add")}
                        </Button>
                      )}
                      <Button
                        type="button"
                        color="success"
                        className="me-2 btn-label"
                        onClick={() => {
                          history.push("/tax-deduct/batch");
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        Upload chứng từ theo đợt
                      </Button>
                      <CustomDateFilter
                        isFullInput={true}
                        onFilter={data => {
                          console.log("🚀 ~ CustomDateFilter onFilter :", {
                            data,
                          });
                          const { comparator, date } = data;
                          params.columnFilter = customFilterHeader({
                            comparator,
                            date,
                            fieldQuery: "ttchung_nlap",
                            paramsColumnFilter: params.columnFilter,
                          });
                          dispatch(getListTaxDeducts(params));
                        }}
                        column={{
                          dataField: "ttchung_nlap",
                        }}
                        defaultValue={defaultValueFilterHeader}
                      />
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
